import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import { useDashboardFilterOptions } from '../../queries/hooks/useDashboardFilterOptions'

type ProgramSelectorProps = {
  value: string[]
  onChange: (value: string[]) => void
} & Omit<
  AutocompleteProps<string, true, false, false>,
  'onChange' | 'value' | 'options' | 'renderInput' | 'multiple'
>

const ProgramSelector = ({ value, onChange, ...rest }: ProgramSelectorProps) => {
  const { data: allOptions, isLoading: isLoadingOptions } = useDashboardFilterOptions()

  return (
    <Autocomplete
      multiple
      options={allOptions?.programs.map((program) => program ?? '') ?? []}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      size="small"
      renderOption={(props, option) => (
        <li {...props} key={option}>
          <Checkbox checked={value.includes(option)} size="small" />
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={
            value.length > 0
              ? 'Select programs to check compliance for'
              : 'Will apply to all programs'
          }
          inputProps={{ ...params.inputProps, 'data-qa-id': 'config-programs-input' }}
        />
      )}
      loading={isLoadingOptions}
      {...rest}
    />
  )
}

export default ProgramSelector
